module.exports = __webpack_public_path__ + "static/media/memoriesText.2b89c5fa.png";